import React from "react";
import $ from 'jquery';
import BottomModalHeader from "./BottomModalHeader";
import RoomOverviewContent from "./Content/RoomOverviewContent";
import TutorialRoomContent from "./Content/TutorialRoomContent";
import BottomModalContent from "./BottomModalContent";
import RoomSwitchContent from "./Content/RoomSwitchContent";
import Hammer from "hammerjs";
import GalleryIndexContent from "./Content/GalleryIndexContent";
import { API } from "../../handler/ApiHandler";
import InfoSpot from "../../models/InfoSpot";
import BottomModalState from "../../models/BottomModalState";
import $events from '../../blocs/EventBloc';
import { toast } from "react-toastify";

export default class BottomModal extends React.Component {

    constructor( props ) {
        super(props);

        this.bottomModalRef = React.createRef();
        this.toastId        = React.createRef();
        this.hammerStage    = null;
    }

    onTap = ( e ) => {
        // e.srcEvent.preventDefault();
        // e.srcEvent.stopPropagation();
        console.log("bottomModal/tap");
        $events.$emit('bottomModal/tap');

        if ( this.props.currentState.isOpen ) {
            return;
        }
        this.props.roomBloc.openBottomModal();
    };

    componentWillUnmount() {
        // this.hammerStage.detach();
    }

    componentDidMount() {
        // this.hammerStage = new Hammer(this.bottomModalRef.current, {});
        // this.hammerStage.domEvents = true;
        //
        // this.hammerStage
        //     .on('tap', this.onTap);

        let _this = this;

        console.log(`a[href^="${location.protocol}//${location.hostname}/info/"]`);

        $(this.bottomModalRef.current).on('click', `a[href^="${location.protocol}//${location.hostname}/info/"]`, function( e ) {
            console.log("ℹ️ bottomModal/click on info link");
            e.preventDefault();
            let url  = $(this).attr('href');
            let text = $(this).text();

            _this.toastId.current = toast.info(`⏳ ${text} wird geladen..`, {
                position:        "bottom-center",
                autoClose:       false,
                hideProgressBar: false,
                closeOnClick:    true,
                pauseOnHover:    true,
                draggable:       true,
                progress:        undefined
            });

            API.getInfoSpotByUrl(url)
               .then(res => {
                   if ( typeof res.ID === "undefined" ) {
                       /// TODO-wfp: add error msg
                       console.log("No infospot response!");
                       return;
                   }

                   toast.dismiss(_this.toastId.current);

                   let infoSpot = new InfoSpot({
                       spot:  res,
                       x:     0,
                       y:     0,
                       index: 1
                   });

                   // let bottomModalState = new BottomModalState({
                   //     obj:  infoSpot,
                   //     type: ( infoSpot.type === 'room' ) ? 'room' : 'content'
                   // });
                   // $events.$emit('bottomModal/createNew', bottomModalState);

                   _this.props.roomBloc.showInfoSpotContent(infoSpot);
                   _this.props.roomBloc.currentState.bottomModalState.open();
                   _this.props.roomBloc.pushState();
               });

        });
    }

    componentDidUpdate( prevProps, prevState, snapshot ) {

    }

    render() {
        if ( typeof this.props.currentState == 'undefined' ) {
            return <div></div>;
        }

        return (
            <div
                className={`bottom-modal  ${( this.props.currentState.isOpen ) ? 'bottom-modal--open' : ''}  ${( this.props.currentState.isClosed ) ? 'bottom-modal--closed' : ''}`}
                ref={this.bottomModalRef}
                onClick={this.onTap}>

                <div className="grabber  bottom-modal__grabber"></div>

                <BottomModalHeader currentState={this.props.currentState}></BottomModalHeader>

                {!( this.props.currentState.obj?.isTutorialRoom ?? false ) &&
                <div className="bottom-modal__content">
                    {this.props.currentState.type === 'content' &&
                    <BottomModalContent currentState={this.props.currentState}></BottomModalContent>}

                    {this.props.currentState.type === 'room' &&
                    <RoomSwitchContent currentState={this.props.currentState}></RoomSwitchContent>}

                    {this.props.currentState.type === 'overview' &&
                    <RoomOverviewContent currentState={this.props.currentState} roomBloc={this.props.roomBloc}></RoomOverviewContent>}

                    {this.props.currentState.type === 'gallery_index' &&
                    <GalleryIndexContent currentState={this.props.currentState}></GalleryIndexContent>}
                </div>}

                {( this.props.currentState.obj?.isTutorialRoom ?? false ) &&
                <div className="bottom-modal__content">
                    <TutorialRoomContent
                        currentState={this.props.currentState}
                        tutorialState={this.props.tutorialState}>
                    </TutorialRoomContent>
                </div>
                }
            </div>
        );
    }

}
